<template>
    <div class="base_box">
        <div class="base_form base_form_padding base_form_height"  >
            <div class="base_form_title">人员设置</div>
            <el-form class="mt20  " ref="form"  label-width="80px" style="margin-bottom: 16px;margin-left: 20px;" hide-required-asterisk>
                <el-form-item label="人员角色" prop="nav_title">
                    <el-radio-group v-model="post.role">
                        <!-- <el-radio label="1">采购</el-radio> -->
                        <el-radio label="2">仓储</el-radio>
                        <!-- <el-radio label="3">销售</el-radio>
                        <el-radio label="4">财务</el-radio>
                        <el-radio label="5">分拣</el-radio> -->
                        <el-radio label="6">分拣员</el-radio>
                    </el-radio-group>
                    <!-- <div class="base_tips mt5">请设置采购员账号状态</div> -->
                </el-form-item>
                <el-form-item v-if="post.id==''" label="管理仓库" prop="nav_title">
                    <el-select placeholder="请选择管理仓库" size="small" v-model="post.warehouse_id"  style="width: 400px;">
                    	<el-option
                    	  v-for="item in warehouse"
                    	  :key="item.id"
                    	  :label="item.name"
                    	  :value="item.id">
                    	</el-option>
                    </el-select>
                    <!-- <div class="base_tips mt5">请设置采购员账号状态</div> -->
                </el-form-item>
				<el-form-item label="人员姓名" prop="nav_title">
                    <el-input placeholder="请输入" size="small" v-model="post.name" type="text" style="width: 400px"></el-input>
                    <!-- <div class="base_tips mt5">请填写采购员姓名</div> -->
                </el-form-item>

				<el-form-item label="联系电话" prop="nav_title">
				    <el-input placeholder="请输入" size="small" v-model="post.mobile" type="text" style="width: 400px"></el-input>
				    <!-- <div class="base_tips mt5">请填写采购员电话，联系电话作为登录账号</div> -->
				</el-form-item>
				<el-form-item v-if="post.id==''" label="登录账号" prop="nav_title">
				    <el-input placeholder="请输入" size="small" v-model="post.username" type="text" style="width: 400px"></el-input>
				    <!-- <div class="base_tips mt5">请填写采购员电话，联系电话作为登录账号</div> -->
				</el-form-item>
				<el-form-item v-if="post.id==''" label="登录密码" prop="nav_title">
				    <el-input placeholder="请输入" size="small" v-model="post.password" type="password" style="width: 400px"></el-input>
				    <div class="base_tips mt5">请设置采购员登录密码</div>
				</el-form-item>
				<el-form-item label="账号状态" prop="nav_title">
				    <el-radio-group v-model="post.status">
				        <el-radio label="0">禁用</el-radio>
				        <el-radio label="1">启用</el-radio>
				    </el-radio-group>
				    <div class="base_tips mt5">请设置采购员账号状态</div>
				</el-form-item>
            </el-form>
        </div>
        <div class="base_fixed_bottom">
			<el-button class="  base_but_style  " type="info"  plain @click="toback">返回</el-button>
            <el-button class="base_but_style base_save_but" type="primary" @click="submitForm">保存</el-button>
        </div>
		
		<xsk-manage :managehide.sync="imgplugin.show" @confirm="imgpluginFun" :multiple="imgplugin.multiple"
			:count="imgplugin.count" is_rest>
		</xsk-manage>
    </div>
</template>

<script>
import { eltips } from "@/util/util.js";
import { jsonToFormData } from "@/util/weishop/format";
export default {
    data() {
        return {
            post: {
				id:'',
                status: '1',
                role: '2',
                name: '',
                mobile: '',
                username: '',
                password: '',
                warehouse_id: ''
            },
			imgplugin: {
				show: false,
				multiple: false,
				count: 1,
				imgName: "",
			},
			warehouse:[]
        };
    },
    created() {
		let _this = this
		if(_this.$route.query.id){
			_this.getInit();
			_this.post.id = _this.$route.query.id
		}
		_this.axios
		    .get("/api/weishop/admin/plugin/erp/warehouse/tree_index")
		    .then((res) => {
				_this.warehouse = res.data
		    });
    },
    methods: {
		toback() {
			this.$router.go(-1);
		},
        radioChange() {
            let _this = this
            if (_this.post.order.cancel_check == 0) {
                _this.post.order.order_cancel_minutes = 0
            }
        },
        getInit() {
            let _this = this;
            _this.axios
                .get("/api/weishop/admin/plugin/erp/worker/first/"+_this.$route.query.id)
                .then((res) => {
                    if (res.code == 200) {
                        if (res.data) {
							_this.post.role = res.data.role
							_this.post.id = res.data.id
							_this.post.status = res.data.status
							_this.post.name = res.data.name
							_this.post.mobile = res.data.mobile
							_this.post.username = res.data.username
							_this.post.password = res.data.password
							_this.post.warehouse_id = res.data.warehouse_id
                        }
                    } else {
                        eltips(res.msg, "error");
                    }
                });
        },
        submitForm() {
			let _this = this
            let url = "/api/weishop/admin/plugin/erp/worker/store";
            if(_this.$route.query.id){
				url = '/api/weishop/admin/plugin/erp/worker/store/'+_this.$route.query.id
			}
            this.axios.post(url, _this.post).then((res) => {
				if (res.code == 200) {
					eltips(res.msg, "success");
					_this.toback()
				} else {
					eltips(res.msg, "error");
				}
			});
        },
		//打开图片上传
		openimgplugin(e) {
			this.imgplugin.imgName = e;
			this.imgplugin.show = true;
		},
		//图片管理器回传
		imgpluginFun(e) {
			if (e.imgobjs.length == 0) {
				return;
			}
			this.post[this.imgplugin.imgName] = e.imgobjs[0]["url"];
		},
    },
};
</script>

<style lang="less" scoped>
.tipstext {
    border: 1px solid #abdcff;
    background: #f0faff;
    color: #006aff;
    padding: 10px;
    border-radius: 2px;
    margin-bottom: 10px;
    width: fit-content;
}

::v-deep .el-form-item__label {
    text-align: left;
    line-height: 34px;
}

::v-deep .chengzhong .el-form-item__label {
    width: 80px !important;
}

.ml15 {
    margin-left: 15px;
}

.nml15 {
    margin-left: -15px;
}

.mb16 {
    margin-bottom: 16px;
}

.pt5 {
    padding-top: 5px;
}
.goodsimage {
		.imgbox {
			border: 1px dashed #e9edef;
			width: 80px;
			height: 80px;
			margin-bottom: 10px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			cursor: pointer;
			margin-right: 12px;
			position: relative;

			.img {
				width: 100%;
				height: 100%;
			}

			.addicon {
				font-size: 28px;
				color: #006aff;
			}

			.text {
				font-size: 12px;
				color: #b8b9bd;
				line-height: 16px;
			}

			.delicon {
				display: none;
				font-size: 20px;
				position: absolute;
				right: -8px;
				top: -8px;
			}

			&:hover {
				.delicon {
					display: block;
				}
			}
		}

		.imgbox2 {
			&:extend(.imgbox);
			width: 180px;
			height: 320px;
		}

		.advbox {
			width: 100px;
			height: 100px;
		}
	}
</style>
